import PaymentHistory from "./payment-history.page";

export default PaymentHistory;
